import { connect } from 'react-redux';
import formEditorActions from '../../stores/FormEditor/actions';

import FormEditor from '../components/formEditor';

const mapStateToProps = (state) => {
  const { formEditor } = state;
  const {
    isInitializing,
    isSaving,
    isPublishing,
    isDeleting,
    isDeleted,
    isModified,
    teamName,
    mode,
    selectedElement,
    form
  } = formEditor;

  return {
    isInitializing,
    isSaving,
    isPublishing,
    isDeleting,
    isDeleted,
    isModified,
    teamName,
    mode,
    selectedElement,
    form
  };
};

const mapDispatchToProps = dispatch => ({
  onFormEditorInitialize: (formId, token) => dispatch(
    formEditorActions.formEditorInit(formId, token)
  ),
  onFormSave: (republish, token) => dispatch(
    formEditorActions.formSave(republish, token)
  ),
  onFormDelete: token => dispatch(
    formEditorActions.formDelete(token)
  ),
  onFormPublish: token => dispatch(
    formEditorActions.formPublish(token)
  ),
  onFormEditorModeChange: mode => dispatch(
    formEditorActions.formEditorModeChange(mode)
  ),
  onFormElementSelected: selectedElement => dispatch(
    formEditorActions.formElementSelected(selectedElement)
  ),
  onFormElementChange: target => dispatch(
    formEditorActions.formElementChange(target)
  ),
  onFormElementTypeChange: type => dispatch(
    formEditorActions.formElementTypeChange(type)
  ),
  onMoveUp: id => dispatch(
    formEditorActions.formElementMoveUp(id)
  ),
  onMoveDown: id => dispatch(
    formEditorActions.formElementMoveDown(id)
  ),
  onFormElementRemove: id => dispatch(
    formEditorActions.formElementRemove(id)
  ),
  onFormPreviewChange: form => dispatch(
    formEditorActions.formPreviewChange(form)
  ),
  onFormEditorAddElement: newElementType => dispatch(
    formEditorActions.formDetailsAddElement(newElementType)
  ),
  onFormElementRequiredChange: id => dispatch(
    formEditorActions.formElementRequiredChange(id)
  ),
  onFormElementOptionsChange: optionsText => dispatch(
    formEditorActions.formElementOptionsChange(optionsText)
  ),
  onPrivacyChange: (privacy, token) => dispatch(
    formEditorActions.formPrivacyChange(privacy, token)
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FormEditor);
